var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"promo-badge",class:[
    `promo-badge--size_${_vm.size}`,
    {
      'promo-badge--shadow': _vm.shadow,
    }
  ]},[_c('ResponsiveImage',{staticClass:"promo-badge__image",attrs:{"srcset":_vm.images}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }